<script>
// type check-templates fail without an export
export default {}
</script>
<template>
  <div class="text-right q-mt-sm">
    <a href="https://www.amcharts.com/" target="_blank">
      <span class="-fg-semi-muted">Built with</span>

      <img
        alt="Built with amCharts"
        src="./img/amcharts-logo.svg"
        width="75"
        height="32"
        rel="noreferrer"
      />
    </a>
  </div>
</template>
<style scoped="true">
a {
  text-decoration: none;
}
</style>
